import { Component, Input, ViewChild } from "@angular/core"; import { Location } from "@angular/common";
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { EmployeEntite } from '../entites/employe';
import { DonneesBaseService } from '../services/donnees-base-service';
import { ItemService } from "../services/item-service";
import { MessageService } from "primeng/api";

@Component({
    templateUrl: './saisie-numero.component.html',
})
export class SaisieNumeroComponent {

    @Input() numero?: string;

    isProchainDisabled: boolean = false;
    numeroValide: boolean = null;
    validationEnCours: boolean = false;

    @ViewChild('champNumero') inputNumero;

    constructor(
        public sdb: DonneesBaseService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public itemsService: ItemService,
        public messageService: MessageService
    ) { }

    ngOnInit() {
        setTimeout(() => {
            this.inputNumero.nativeElement.focus();
        }, 100);

    }

    Confirmer() {
        if (this.numero) {
            this.ref.close(this.numero);
        }
    }

    Annuler() {
        this.ref.close(null);
    }

    obtenirProchainNumero() {
        if (this.numero.length > 0 && !this.isProchainDisabled) {
            this.itemsService.ObtenirProchainNumero(this.numero).then(x => {
                let newNumero = this.numero + x.valeur;
                this.numero = newNumero;
                this.isProchainDisabled = this.isNumberFormatValid(this.numero);
            });
        }
    }

    private isNumberFormatValid(numero: string): boolean {
        if (!numero) return false;
        const pattern = /^[a-zA-Z0-9]+-\d+$/;
        return pattern.test(numero);
    }

    verifierNumero() {
        this.validationEnCours = true;
        this.itemsService.VerifierExiste(this.numero).then(x => {
            this.numeroValide = x.valeur == 0;
            this.validationEnCours = false;
        }).catch(e => {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la vérification du numéro' });
            this.numeroValide = false;
            this.validationEnCours = false;
        });
    }
}